import { render, staticRenderFns } from "./org_table.vue?vue&type=template&id=2d187762"
import script from "./org_table.vue?vue&type=script&lang=js"
export * from "./org_table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports